// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2-agu","selected":"Chip_selected__1cLIL"};